export default "__VITE_ASSET__CX2iKJPK__"